import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "112",
  height: "112",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M75.47 1a8 8 0 0 1 5.44 2.13l.22.21 27.53 27.54a8 8 0 0 1 2.33 5.35l.01.3v38.94a8 8 0 0 1-2.13 5.44l-.21.21-27.53 27.54a8 8 0 0 1-5.36 2.33l-.3.01H36.53a8 8 0 0 1-5.44-2.13l-.21-.21L3.34 81.12a8 8 0 0 1-2.33-5.35l-.01-.3V36.53a8 8 0 0 1 2.13-5.44l.21-.21L30.88 3.34a8 8 0 0 1 5.35-2.33l.3-.01h38.94zM56 72.64a6.21 6.21 0 1 0 0 12.43 6.21 6.21 0 0 0 0-12.43zm4.47-46.14H51.5a1 1 0 0 0-.97.91v.12l.94 35c.02.5.4.9.89.96l.11.01h7.06a1 1 0 0 0 .99-.86v-.11l.95-35.03a1 1 0 0 0-.88-1h-.12z",
  "fill-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }